import React from 'react'
import ReservationBuilderCustomerCards from '../ReservationBuilderCustomerCards'
export default class ReservationBuilderPaymentInformationStep extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div >
        <ReservationBuilderCustomerCards {...this.props} />
      </div> 
    );
  };
};